import { AiMessageChunk } from '@texas/api/endpoints/chat/aiMessageTypes';
import { RenderComponent } from './components/RenderComponent';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Box } from '@chakra-ui/react';
import { aiEvents } from './events';
import { EntityItem } from './types';
import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';
import {
  convertToEnum,
  ensureEnumNumber,
} from '@texas/utils/helpers/enumHelpers';
import { basicSlateParagraph } from './utils';
import { randomIdentifier } from '@texas/utils/helpers/commonHelpers';
import { HoverCard } from '../shared/HoverCard';
import { hoverCards } from './renders/hoverCards/hoverCards';

export function AiChatMessageChunkRenderer(props: {
  chunks: AiMessageChunk[];
}) {
  return (
    <Box overflowX="auto">
      {props.chunks.map((x, i) => {
        return (
          <React.Fragment key={i}>
            {x.componentId && x.componentType && x.componentEntityType ? (
              <RenderComponent
                componentId={x.componentId}
                componentType={x.componentType}
                entityType={x.componentEntityType}
              />
            ) : (
              <Box w="fit-content" lineHeight="7" className="markdown-body">
                <ReactMarkdown
                  urlTransform={(url) => {
                    return url;
                  }}
                  components={{
                    a: ({
                      ...props
                    }: {
                      node?: any;
                      children?: React.ReactNode;
                      href: string;
                    }) => {
                      const { children, href } = props;
                      const parsed = parseLinkData(href);

                      return (
                        <HoverCard
                          content={
                            typeof parsed !== 'string'
                              ? hoverCards[
                                  ensureEnumNumber(
                                    ChatMessageEntityLinkType,
                                    parsed.type,
                                  )
                                ]?.(parsed.id)
                              : null
                          }
                        >
                          <button
                            onClick={(e) => {
                              e.preventDefault();

                              // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                              if (typeof parsed === 'string') {
                                aiEvents.updateMessage.dispatch(
                                  basicSlateParagraph(parsed),
                                );
                                return;
                              }
                              const entity: EntityItem = {
                                id: parsed.id,
                                name: parsed.str,
                                type: parsed.type,
                                identifier: randomIdentifier(),
                              };
                              aiEvents.appendEntity.dispatch({
                                item: entity,
                                type: parsed.type,
                              });
                            }}
                          >
                            {children}
                          </button>
                        </HoverCard>
                      );
                    },
                  }}
                >
                  {x.text}
                </ReactMarkdown>
              </Box>
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
}

function sanitizeText(text: string) {
  return text.trim().replaceAll('[', '').replaceAll(']', '');
}

function parseLinkData(href: string) {
  const data = decodeURIComponent(href.replace('confirm:', ''));
  const sanitized = sanitizeText(data);
  const split = sanitized.split('-');
  const dataSplit = split[1].split(':');
  if (dataSplit.length !== 2) {
    const str = sanitized.replaceAll('-', ' ');
    return str;
  }
  const type = convertToEnum(ChatMessageEntityLinkType, dataSplit[0]);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!type) {
    return split[0];
  }

  const id = parseInt(dataSplit[1] || '0');
  return { str: split[0], type, id };
}
